import { connect } from 'react-redux'
import NewsletterView from '../../../components/Sections/Newsletter'
import { loadNewsletters, loadNewsletterBySector, loadNewslettersByPagination } from '../../../actions/newsletter';

const mapStateToProps = (state) => {
  return {
    newsletters: state.newsletter.list,
    current_page: state.newsletter.current_page,
    last_page: state.newsletter.last_page,
    total: state.newsletter.total,
    loading: state.newsletter.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadNewsletters: (pl, p) => dispatch(loadNewsletters(pl, p)),
    onFilterCategory: value => dispatch(loadNewsletterBySector(value)),
    loadNewslettersByPagination: (pl, p) => dispatch(loadNewslettersByPagination(pl, p)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsletterView)


// WEBPACK FOOTER //
// ./src/containers/Sections/Newsletter/index.js